import React from 'react';
import styled from 'react-emotion';
import { GridRowStyle } from './GridHelper';

export const GridRow = styled('div')(GridRowStyle);
